import { evaluatePurchase, historicalPosition } from '../../../src/features/cron-calculator/cron-calculator-math.js';
import { bandBadge, el, fmt, itemIcon, LABELS } from './dom.js';

function metric(label, value, className = '') {
  return el('div', { className: `mc-result-metric ${className}` }, [el('span', { text: label }), el('strong', { text: value })]);
}

// O que ainda falta para o cálculo (e a publicação) fazer sentido.
export function missingFields(input) {
  const missing = [];
  if (!input.packageName) missing.push({ field: 'mcPackageName', label: 'nome do pacote' });
  if (!(input.originalPrice > 0)) missing.push({ field: 'mcOriginalPrice', label: 'preço em Pérolas' });
  if (!input.items.some((item) => item.quantity > 0 && (item.itemId || item.name))) missing.push({ field: 'mcItems', label: 'quantidade de algum item' });
  return missing;
}

// Posição frente ao histórico do Marni: média, diferença e percentil.
export function cronEfficiency(cronPerPearl, stats) {
  const position = historicalPosition(cronPerPearl, stats.distribution, { minSample: stats.minHistorySample, thresholds: stats.bandThresholds });
  const lines = [];
  if (position.enough) {
    const direction = position.vsAverage >= 0 ? 'acima' : 'abaixo';
    lines.push(el('p', {}, ['Média da comunidade: ', el('strong', { text: `${fmt.cpp(position.average)} Cron/Pérola` })]));
    lines.push(el('p', {}, [el('strong', { text: `${fmt.signedPct(position.vsAverage)}` }), ` ${direction} da média`]));
    lines.push(el('p', {}, ['Melhor que ', el('strong', { text: fmt.pct(position.percentile) }), ` dos ${fmt.int(position.sample)} pacotes registrados.`]));
  } else if (cronPerPearl > 0) {
    const left = Math.max(stats.minHistorySample - position.sample, 1);
    lines.push(el('p', { text: `Faltam ${left} ${left === 1 ? 'registro' : 'registros'} da comunidade para comparar com a média.` }));
  }
  return { position, element: el('div', { className: 'mc-efficiency' }, [bandBadge(position.band), ...lines]) };
}

// Antes de haver preço e Crons, o painel explica o que fazer em vez de mostrar zeros.
function renderGuide(host) {
  host.className = 'mc-result mc-result-empty';
  host.replaceChildren(
    el('p', { className: 'eyebrow', text: 'Resultado' }),
    el('h2', { text: 'Quanto cada Pérola rendeu?' }),
    el('ol', { className: 'mc-guide' }, [
      el('li', { text: 'Informe o preço do pacote em Pérolas (e o desconto, se houver).' }),
      el('li', { text: 'Diga quantas Pedras Cron ou itens vieram nele.' }),
      el('li', { text: 'O resultado aparece aqui na hora, comparado com a comunidade.' })
    ])
  );
}

export function renderPackageResult(host, input, stats) {
  const metrics = evaluatePurchase(input);
  if (!(input.originalPrice > 0) || !(metrics.totalCrons > 0 || metrics.totalSilver > 0)) {
    renderGuide(host);
    return metrics;
  }
  const { position, element } = cronEfficiency(metrics.cronPerPearl, stats);
  host.className = `mc-result mc-result-${position.band}`;
  host.replaceChildren(
    el('p', { className: 'eyebrow', text: 'Resultado' }),
    input.packageName ? el('div', { className: 'mc-result-title' }, [input.catalogPackage ? itemIcon(input.catalogPackage.iconPath, { alt: '' }) : null, el('h2', { text: input.packageName })]) : null,
    el('div', { className: 'mc-result-hero' }, [
      el('span', { text: 'Cron por Pérola' }),
      el('strong', { text: fmt.cpp(metrics.cronPerPearl) }),
      el('small', { className: 'mc-result-formula', text: 'Crons obtidas ÷ Pérolas pagas. Quanto maior, melhor.' }),
      el('small', { text: metrics.pearlsPer1000Crons ? `${fmt.int(metrics.pearlsPer1000Crons)} Pérolas por 1.000 Crons` : 'Nenhuma Cron extraída neste pacote' })
    ]),
    element,
    el('div', { className: 'mc-result-grid' }, [
      metric('Preço pago', `${fmt.int(metrics.effectivePearls)} Pérolas`),
      metric('Crons obtidas', fmt.int(metrics.totalCrons)),
      metric('Economia', metrics.savedPearls ? `${fmt.int(metrics.savedPearls)} Pérolas (${fmt.pct(input.discountPercent)})` : 'Sem desconto'),
      metrics.totalSilver > 0 ? metric('Valor em Silver', fmt.silver(metrics.totalSilver)) : metric('Itens no pacote', fmt.int(metrics.totalItems))
    ]),
    el('p', { className: 'mc-result-type', text: `${LABELS.packageTypes[input.packageType] || ''} · ${LABELS.regions[input.region] || input.region} · ${fmt.date(input.purchasedAt)}` })
  );
  return metrics;
}

// Resumo de uma linha junto do botão de publicar: no celular o painel completo
// fica abaixo do formulário, então o veredito e o que falta aparecem aqui.
export function renderQuickResult(host, input, stats) {
  const metrics = evaluatePurchase(input);
  const missing = missingFields(input);
  if (missing.length) {
    host.dataset.state = 'missing';
    host.replaceChildren(el('span', { text: `Falta: ${missing.map((item) => item.label).join(', ')}.` }));
    return missing;
  }
  const { position } = cronEfficiency(metrics.cronPerPearl, stats);
  host.dataset.state = position.band;
  host.replaceChildren(
    el('strong', { text: `${fmt.cpp(metrics.cronPerPearl)} Cron/Pérola` }),
    el('span', { text: ` · ${LABELS.bands[position.band]?.label || ''}` })
  );
  return missing;
}
